/**
 * Adds locale prefix to relative URLs if needed.
 * Leaves external URLs (http/https) and URLs that already have a locale prefix unchanged.
 */
export function addLocalePrefix(url: string | null | undefined, locale: string): string {
  if (!url) return "";

  // Don't modify external URLs
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("//")) {
    return url;
  }

  // Don't modify if it's not a relative path
  if (!url.startsWith("/")) {
    return url;
  }

  // Check if URL already has a locale prefix
  const segments = url.split("/").filter(Boolean);
  if (segments.length > 0) {
    const firstSegment = segments[0];

    // If the first segment matches the current locale, URL already has the correct prefix
    if (firstSegment === locale) {
      return url;
    }

    // If first segment looks like a locale (contains underscore or is 2-5 chars),
    // assume it's a different locale and we should replace it
    // Common locale patterns: en_GB, en-GB, en, fr_FR, etc.
    if (firstSegment.includes("_") || firstSegment.includes("-") || firstSegment.length >= 2 && firstSegment.length <= 5 && /^[a-z]{2}/i.test(firstSegment)) {
      // Replace the existing locale prefix with the current one
      const restOfPath = "/" + segments.slice(1).join("/");
      return `/${locale}${restOfPath}`;
    }
  }

  // Add locale prefix to URLs without one
  return `/${locale}${url}`;
}